// Changes the Main page title based off where we are going
export const changePageTitle = text => ({
	type: 'UPDATE_PAGE_TITLE',
	text
});



// WEBPACK FOOTER //
// ./src/actions/index.js